function initCookieAlert() {
  new cookieNoticeJS({
    // Localizations of the notice message
    messageLocales: {
      en:
        "W ramach naszej strony stosujemy pliki cookies w celu dostosowania treści do indywidualnych potrzeb. Korzystanie ze strony bez zmiany ustawień oznacza, że cookies będą zamieszczane na Twoim urządzeniu końcowym. Zawsze możesz dokonać zmiany ustawień cookies.  ",
    },

    // Localizations of the dismiss button text
    buttonLocales: {
      en: "Rozumiem",
    },
    fontSize: 11,

    // Position for the cookie-notifier (default=bottom)
    cookieNoticePosition: "bottom",

    // Shows the "learn more button (default=false)
    learnMoreLinkEnabled: true,

    // The href of the learn more link must be applied if (learnMoreLinkEnabled=true)
    learnMoreLinkHref:
      "./klauzula_informacyjna_o_przetwarzaniu_danych_osobowych_(rodo)-skonwertowany.pdf",

    // Text for optional learn more button
    learnMoreLinkText: {
      en: "Dowiedz się więcej",
    },

    // The message will be shown again in X days
    expiresIn: 30,

    // Specify a custom font family
    fontFamily: "inherit",

    // Dismiss button background color
    buttonBgColor: "#6d9d88",

    // Dismiss button text color
    buttonTextColor: "#fff",

    // Notice background color
    noticeBgColor: "rgb(35, 33, 39)",

    // Notice text color
    noticeTextColor: "#fff",

    // the learnMoreLink color (default='#009fdd')
    linkColor: "#fff",

    // The target of the learn more link (default='', or '_blank')
    linkTarget: "_blank",

    // Print debug output to the console (default=false)
    debug: false,
  });
}

export default initCookieAlert;
